import { createContext } from 'react';
import {
  EnvironmentVariableConfig,
  defaultEnvironmentVariableConfig,
} from 'types/EnvironmentVariableConfig';

export const EnvironmentVariableContext =
  createContext<EnvironmentVariableConfig>(defaultEnvironmentVariableConfig);
